import { useMemo } from 'react';
import { usePermissionsContext } from '../context/permissions-context';
import type { TPageNavbarItem } from 'common/types';

interface INavbarItemWithPermission extends TPageNavbarItem {
  permission?: any;
}

interface IUsePageNavbarPermissionsProps {
  navbarItems: INavbarItemWithPermission[];
}

export const usePageNavbarPermissions = ({ navbarItems }: IUsePageNavbarPermissionsProps) => {
  const { hasPermission } = usePermissionsContext();

  const filteredNavbarItems = useMemo(() => {
    return navbarItems.filter(item => {
      // If no permission is specified, show the item
      if (!item.permission) {
        return true;
      }

      // Check if user has the required permission
      return hasPermission(item.permission.slug);
    });
  }, [navbarItems, hasPermission]);

  return {
    filteredNavbarItems,
    hasAnyVisibleItems: filteredNavbarItems.length > 0
  };
};
